const mEditionBillingMyShoppingRecord = {
  mEditionBillingMyShoppingRecord: {
    infoLeft: {
      compra: {
        cancelDate: 'Tendrás acceso a los cursos incluidos hasta el',
        compensa: {
          linea1: 'Compensación de',
          linea2: 'por cambio de Medio de Pago'
        },
        cupon: {
          linea1First: 'Se aplicó descuento',
          linea1Second: 'del'
        },
        free: 'Gratis',
        fromDate: 'desde',
        iva: 'Se aplicó impuesto (IVA) del',
        labelState: 'Compra',
        montoParcial: 'Monto Parcial de',
        plan: {
          first: 'A pagar en',
          second: 'con'
        },
        proyectos: 'Los cursos incluidos son los siguientes',
        suscripcion: {
          idExterno: 'ID de suscripción en',
          payFirst: 'El primer pago será el',
          payNext: 'El próximo pago será el'
        },
        total: 'Monto total de',
        trial: 'Periodo de prueba de',
        trialPay: 'Pago por periodo de prueba de'
      },
      title: 'DETALLE DE COMPRA'
    },

    infoRight: {
      payMethodChange: {
        btn: 'CAMBIAR MEDIO DE PAGO',
        paragraph: '¿Deseas cambiar de medio de pago?',
        pending: {
          btn: 'Ver Detalle',
          paragraph: '¡Hemos detectado un intento de Cambio de Medio de Pago!'
        }
      },

      invoiceData: {
        movil: 'Móvil',
        tel: 'Teléfono',
        title: 'DATOS DE FACTURACIÓN'
      }
    },

    table: {
      title: 'LISTADO DE PAGOS',
      thDate: 'FECHA',
      thState: 'ESTADO',
      thTax: 'IMPUESTO',
      thAmount: 'TOTAL',
      thMethod: 'MEDIO',
      thToPay: 'A PAGAR',
      thInvoice: 'COMPROBANTE'
    },

    tooltips: {
      actions: 'Acciones',
      edit: 'Editar',
      shopping: 'Ver Comp.',
    }
  }
}

export default mEditionBillingMyShoppingRecord
